// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "BadgeTooltip" + "." + "598dc17226d3810e" + ".css"
}